/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__route_selector_no_address = /** @type {(inputs: {}) => string} */ () => {
	return `Unbekannte Orte.`
};

const en_route__route_selector_no_address = /** @type {(inputs: {}) => string} */ () => {
	return `Places unknown.`
};

const es_route__route_selector_no_address = /** @type {(inputs: {}) => string} */ () => {
	return `Lugares desconocidos.`
};

const fr_route__route_selector_no_address = /** @type {(inputs: {}) => string} */ () => {
	return `Lieux inconnus.`
};

const it_route__route_selector_no_address = /** @type {(inputs: {}) => string} */ () => {
	return `Luoghi sconosciuti.`
};

const nl_route__route_selector_no_address = /** @type {(inputs: {}) => string} */ () => {
	return `Onbekende plaatsen.`
};

const pt_route__route_selector_no_address = /** @type {(inputs: {}) => string} */ () => {
	return `Locais desconhecidos.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_address = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__route_selector_no_address(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__route_selector_no_address", locale)
	if (locale === "de") return de_route__route_selector_no_address(inputs)
	if (locale === "en") return en_route__route_selector_no_address(inputs)
	if (locale === "es") return es_route__route_selector_no_address(inputs)
	if (locale === "fr") return fr_route__route_selector_no_address(inputs)
	if (locale === "it") return it_route__route_selector_no_address(inputs)
	if (locale === "nl") return nl_route__route_selector_no_address(inputs)
	return pt_route__route_selector_no_address(inputs)
};